var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var SvgCopywriting = function (props) { return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", width: "1em", height: "1em" }, props, { children: _jsx("path", { stroke: "currentColor", strokeLinejoin: "round", strokeMiterlimit: 10, strokeWidth: 1.25, d: "M16.312 11.813a1.064 1.064 0 0 0 0-1.5 1.064 1.064 0 0 0-1.5 0l-3.75 3.75-.513 1.537a.372.372 0 0 0 .472.473l1.538-.514zm-7.687 4.125H3.563V2.063h10.875V8.25M5.625 4.688h6.75m-6.75 2.25h6.75m-6.75 6.375h3m-3-4.125h3" }) }))); };
export default SvgCopywriting;
